import { useQuery } from '@tanstack/react-query';

import { sharedGitGetAll } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

export const sharedGitCredentialsQueryKeys = {
  all: ['shared-git-credentials'] as const,
};

async function getSharedGitCredentials() {
  const { data } = await sharedGitGetAll();
  return data;
}

export function useSharedGitCredentials() {
  return useQuery({
    queryKey: sharedGitCredentialsQueryKeys.all,
    queryFn: getSharedGitCredentials,
    ...withError('Unable to load shared git credentials'),
  });
}
